module.exports = __webpack_public_path__ + "static/stock-e57077209812d5e064bcd59756f87371.jpg";